import { Flex } from '@backstage/ui';
import { ShortInfoResourceDrawer } from '../Drawers/ShortInfoResourceDrawer';
import { ResourceErrorsAlert } from '../Messages/ResourceErrorsAlert';
import { ResourcesTable } from '../Tables/ResourcesTable';
import { ResourceCategoryCards } from '../Cards/Summary/ResourceCategoryCards';
import { ResourceStatCards } from '../Cards/Summary/ResourceStatCards';
import { ResourcesToolbar } from './ResourcesToolbar';

/**
 * Resources tab of account (and, until their own rework, project and rule)
 * pages: category filter cards, stat strip, sync alert, toolbar with faceted
 * filters and the grouped resources table — per the resources page mockup.
 */
export function ResourcesTab() {
  return (
    <Flex direction="column" gap="4">
      <ShortInfoResourceDrawer />
      <ResourceCategoryCards />
      <ResourceStatCards />
      <ResourceErrorsAlert />
      <ResourcesToolbar />
      <ResourcesTable />
    </Flex>
  );
}
